import classNames from 'classnames';
import Button from 'src/components/button/Button';
import { componentSizeVariantsEnum } from 'src/constants/common.constants';
import { CheckMarkIcon, CrossIcon } from 'src/components/common/common.icons';
import { Typography } from 'src/components/common';

import './confirmModal.scss';
import { icon } from './confirmModal.constants';
import { hTractionLogoWithText } from 'src/assets/images';

export type TConfirmModal = {
  title: string;
  description?: any;
  openConfirmModal: boolean;
  onClose: () => void;
  onSubmit: () => void;
  submitText: string;
  type: 'success' | 'error' | 'newIdea' | 'confirm';
  loading?: boolean;
  isCancel?: boolean
};

const ConfirmModal = ({
  title,
  description,
  openConfirmModal,
  onClose,
  onSubmit,
  submitText,
  type,
  loading,
  isCancel = true
}: TConfirmModal) => {
  return (
    <div
      className={classNames('confirm-modal-outer', {
        'confirm-modal-outer--is-open': openConfirmModal
      })}
    >
      <div className="confirm-modal">
        <div className="confirm-modal__header">
          <div className="confirm-modal__header__close" onClick={onClose}>
            <CrossIcon />
          </div>
          <div className="confirm-modal__header__icon">
            {type === 'confirm' ? <img src={hTractionLogoWithText} alt="htraction logo" /> : icon[type as keyof typeof icon] || <CheckMarkIcon />}
          </div>
        </div>
        <div className="confirm-modal__content">
          {title && <Typography
            className="confirm-modal__content__title"
            as="h4"
            variant="subHeading-1"
            fontWeight="semiBold"
          >
            {title}
          </Typography>}
          {description && (
            type !== 'confirm' ? <Typography
              className="confirm-modal__content__description"
              as="p"
              variant="body-2"
              fontWeight="regular"
            >
              {description}
            </Typography> : description
          )}
        </div>
        <div className="confirm-modal__buttons">
          {isCancel && <Button
            className="confirm-modal__buttons__button"
            variant="secondary"
            size={componentSizeVariantsEnum.SMALL}
            onClick={onClose}
          >
            <Typography as="span" variant="body-2" fontWeight="semiBold">
              Cancel
            </Typography>
          </Button>}
          <Button
            className="confirm-modal__buttons__button"
            variant="primary"
            size={componentSizeVariantsEnum.SMALL}
            onClick={onSubmit}
            loading={loading}
          >
            <Typography as="span" variant="body-2" fontWeight="semiBold">
              {submitText}
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
